import "./Scss/main.scss";
import "./Css/App.css";
import "./Css/media.css";
import Darkmode from "./Components/DarkMode/Darkmode";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
} from "react-router-dom";
import Login from "./Components/Authentication/Login";
import Register from "./Components/Authentication/Register";
import Verify from "./Components/Authentication/Verify";
// import Success from './Components/Authentication/Success'
// import Header from './Components/Header/Header';

import Resend from "./Components/Authentication/Resend";
import Forgot from "./Components/Authentication/Forgot";
import Reset from "./Components/Authentication/Reset";
import Home from "./Components/Home/home";
import HomeNew from "./Components/Home/HomeNew";
import Verify2fa from "./Components/Authentication/TwoFa";
import {
  addClickSoundListener,
  removeClickSoundListener,
} from "./Components/Sound/Sound";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header1 from "./Components/Header/Header1";
import Flexstaking from "./Components/Staking/Flexstaking";
import Dashboard from "./Components/Dashboard/dashboard";
import Security from "./Components/Security/security";
import Success from "./Components/Authentication/Success";
import Market from "./Components/Market/Market";
import Identity from "./Components/identity/identity";
import Documentverification from "./Components/identity/document-verification";
import Individualverification from "./Components/identity/individual-verification";
import Deposit from "./Components/Deposit/Deposit";
import Profile from "./Components/Profile/profile";
import Instant from "./Components/Instant/instant";
import Withdraw from "./Components/Withdraw/Withdraw";
import Spot from "./Components/Assets/Spot";
import Rewards from "./Components/Assets/Rewards";
import Referral from "./Components/Assets/Referral";
import Reward from "./Components/Reward/Reward";
import Trade from "./Components/Trade/Trade";
import Support from "./Components/Support/Support";
import Error from "./Components/Error/Error";
import UnderConstruction from "./Components/Error/UnderConstruction";
import History from "./Components/History/History";
import P2P from "./Components/P2P/P2P";
import PaymentMethod from "./Components/P2P/PaymentMethod";
import Stake from "./Components/Staking_v1/staking";
import ResendActve from "./Components/Authentication/ResendActve";
import PrivateRoute from "./PrivateRoute";
import Trade2 from "./Components/Trade/Trade2";
import Kycverify from "./Components/identity/Kycverify";
import OrderDetail from "./Components/P2P/OrderDetail";
import PostNewAd from "./Components/P2P/PostNewAd";
import MyAds from "./Components/P2P/MyAds";
import AddPayment from "./Components/P2P/AddPayment";
import Tradetest from "./Components/Trade/Tradetest";
import Flexlayout from "./Components/Flexlayout/Flexlayout"; 
import BotHome from "./Components/Bot/BotHome"; 
import Botdashboard from "./Components/Bot/Botdashboard"; 
import Simpletrade from "./Components/Bot/simpletrade"; 
import DCABot from "./Components/Bot/DcaBot";
import DCAbottrade from "./Components/Bot/DCAbottrade";
import GridBot from "./Components/Bot/GridBot";
import Gridorderlist from "./Components/Bot/Gridorderlist";
import SmartTrade from "./Components/Bot/SmartTrade";
import ScrollToTop from "./ScrollToTop";
import Tutorial from "./Components/Bot/Tutorial";
import { ToastContainer } from "react-toastify";
import { Toaster } from "react-hot-toast";

function App() {
  const location = useLocation();

  const cPath = location.pathname;

  const ProtectedRoute = ({ children }) => {
    const token = localStorage.getItem("token");
    return token ? children : <Navigate to="/login" />;
  };

  const navigate = useNavigate();
  let timer;
  const logout = () => {
    if (localStorage.getItem("Rikosta")) {
      if (timer) {
        clearTimeout(timer);
      }
      timer = setTimeout(() => {
        window.localStorage.clear();
        navigate("/login");
      }, 60000 * 10);
    }
  };
  useEffect(() => {
    logout();
    window.addEventListener("mousemove", logout);
    return () => {
      window.removeEventListener("mousemove", logout);
    };
  }, []);

  return (
    <div
      className="App"
      style={{
        marginTop: [
          ![
            "/login",
            "/register",
            "/resend",
            "/verify",
            "/2fa",
            "/chart",
            "/forgot",
            "/reset",
            "/error",
            "/underconstruction",
            "/success",
          ].includes(cPath)
            ? "66px"
            : "0px",
        ],
        // marginBottom:'80px'
      }}
    >
      <ScrollToTop />
      <Toaster/>
      <Routes>
        <Route exact path="/darkmode" element={<Darkmode />} />
        <Route exact path="/header" element={<Header1 />} />
        <Route exact path="/login" element={<Login />} />
        <Route exact path="/register" element={<Register />} />
        <Route exact path="/resend" element={<Resend />} />
        <Route exact path="/verify" element={<Verify />} />
        <Route exact path="/2fa" element={<Verify2fa />} />
        <Route exact path="/success" element={<Success />} />
        <Route exact path="/forgot" element={<Forgot />} />
        <Route exact path="/reset" element={<Reset />} />
        <Route exact path="/home" element={<Home />} />
        <Route exact path="/" element={<HomeNew />} />
        <Route exact path="/market" element={<Market />} />
        <Route exact path="/trade/:id" element={<Flexlayout />} />
        <Route exact path="/future/:id" element={<Trade2 />} />
        <Route exact path="/bot" element={<BotHome />} />
        <Route exact path="/botdash" element={<Botdashboard />} />
        <Route exact path="/simpletrade" element={<Simpletrade />} />
        <Route exact path="/dcabot" element={<DCABot />} />
        <Route exact path="/dcabottrade" element={<DCAbottrade />} />
        <Route exact path="/gridbot" element={<GridBot />} />
        <Route exact path="/gridorderlist" element={<Gridorderlist />} />
        <Route exact path="/smarttrade" element={<SmartTrade />} />
        <Route exact path="/tutorial" element={<Tutorial />} />
        <Route element={<PrivateRoute />}>
          {/* <Route exact path="/staking" element={<Staking />} /> */}
          <Route exact path="/deposit" element={<Deposit />} />
          {/* <Route exact path="/flexiblestaking" element={<Flexstaking />} /> */}
          <Route exact path="/dashboard" element={<Dashboard />} />
          <Route exact path="/security" element={<Security />} />
          <Route exact path="/identity-verification" element={<Identity />} />
          <Route
            exact
            path="/document-verification"
            element={<Documentverification />}
          />
          <Route
            exact
            path="/individual-verification"
            element={<Individualverification />}
          />
          <Route exact path="/Kycverify" element={<Kycverify />} />
          <Route exact path="/profile" element={<Profile />} />
          <Route exact path="/instant" element={<Instant />} />
          <Route exact path="/withdraw" element={<Withdraw />} />
          <Route exact path="/assets" element={<Spot />} />
          <Route exact path="/p2p" element={<P2P />} />
          <Route exact path="/paymentmethod" element={<PaymentMethod />} />
          <Route exact path="/orderdetails" element={<OrderDetail />} />
          <Route exact path="/postnewad" element={<PostNewAd />} />
          <Route exact path="/addpayment" element={<AddPayment />} />
          <Route exact path="/myads" element={<MyAds />} />
          <Route exact path="/rewards" element={<Rewards />} />
          <Route exact path="/referral" element={<Referral />} />
          <Route exact path="/reward-hub" element={<Reward />} />

          <Route exact path="/testtrade/:id" element={<Tradetest />} />
          <Route exact path="/support" element={<Support />} />
          <Route exact path="/resend" element={<Resend />} />
          <Route exact path="/error" element={<Error />} />
          <Route
            exact
            path="/underconstruction"
            element={<UnderConstruction />}
          />
          <Route exact path="/history" element={<History />} />
          <Route exact path="/stake" element={<Stake />} />
          <Route exact path="/flexlayout/:id" element={<Flexlayout />} />
          {/* <Route exact path="/trade2/:id" element={<Trade2 />} /> */}
        </Route>
      </Routes>
    </div>
  );
}

export default App;
